const  Role = {
    Admin: 'Admin',
    Franchise_Admin:'FRANCHISE-ADMIN', 
    MultiVendor_Admin:'MULTIVENDOR-ADMIN',
    User: 'User',
    Super_Admin:'SUPER-ADMIN'    
};
export default Role;